import { ENVIRONMENTS, SUB_DOMAINS } from '@constants/global.constants';
import { environment } from '@environments/environment';

export const getEnv = () => environment.envName;
export const getSubDomain = () => SUB_DOMAINS[getEnv()];
export const isDev = getEnv() === ENVIRONMENTS.DEV;
export const isStage = getEnv() === ENVIRONMENTS.STAGE;
export const isProd = getEnv() === ENVIRONMENTS.PROD;
